import React from 'react';
import { Link } from 'react-router-dom';

export default function TermsAndConditions() {
  const bg = '#0a0a12';
  const card = '#0e0e1a';
  const border = '#1a1a2a';
  const text = '#b0b0c0';
  const heading = '#f0f0f2';
  const accent = '#a78bfa';

  const section = { marginBottom: 32 };
  const h2Style = { fontSize: 20, fontWeight: 700, color: heading, marginBottom: 12 };
  const pStyle = { color: text, fontSize: 15, lineHeight: 1.8, marginBottom: 12 };

  return (
    <div style={{ background: bg, minHeight: '100vh', padding: '40px 20px' }}>
      <div style={{ maxWidth: 760, margin: '0 auto' }}>
        <Link to="/" style={{ color: accent, fontSize: 14, textDecoration: 'none', display: 'inline-block', marginBottom: 24 }}>&larr; Back to Home</Link>
        <div style={{ background: card, border: '1px solid ' + border, borderRadius: 16, padding: '48px 40px' }}>
          <h1 style={{ fontSize: 32, fontWeight: 800, color: heading, marginBottom: 8 }}>Terms and Conditions</h1>
          <p style={{ color: '#64748b', fontSize: 14, marginBottom: 40 }}>Last updated: March 2, 2026</p>

          <div style={section}>
            <h2 style={h2Style}>1. Agreement to Terms</h2>
            <p style={pStyle}>By accessing or using the IVision CRM platform (&ldquo;Service&rdquo;) operated by IVision Marketing LLC (&ldquo;IVision,&rdquo; &ldquo;we,&rdquo; &ldquo;us,&rdquo; or &ldquo;our&rdquo;), you agree to be bound by these Terms and Conditions. If you do not agree to these terms, do not use the Service.</p>
          </div>

          <div style={section}>
            <h2 style={h2Style}>2. Description of Service</h2>
            <p style={pStyle}>IVision CRM is a multi-tenant business management platform that provides booking, customer relationship management, staff management, SMS communications, invoicing, and related tools for service-based businesses. The platform is accessible via web browser at ivisionmarketing.com.</p>
          </div>

          <div style={section}>
            <h2 style={h2Style}>3. Accounts and Registration</h2>
            <p style={pStyle}>To use our Service, you must create an account and provide accurate, complete information. You are responsible for maintaining the security of your account credentials and for all activities that occur under your account. You must notify us immediately of any unauthorized access. You must be at least 18 years old to create an account.</p>
          </div>

          <div style={section}>
            <h2 style={h2Style}>4. Subscription and Billing</h2>
            <p style={pStyle}>IVision CRM is offered on a monthly subscription basis. The Founding Member plan is $99 per month and the Standard plan is $199 per month. Prices are subject to change with 30 days notice. Subscriptions renew automatically each month. You may cancel your subscription at any time, effective at the end of your current billing period. No refunds are provided for partial months. Additional services such as SMS messaging may incur usage-based fees.</p>
          </div>

          <div style={section}>
            <h2 style={h2Style}>5. SMS Messaging Terms</h2>
            <p style={pStyle}>By using our SMS features, you agree to: only send messages to individuals who have provided consent to receive them; include opt-out instructions in all messages; comply with all applicable laws and regulations including the Telephone Consumer Protection Act (TCPA) and CAN-SPAM Act; not use the messaging service for spam, fraud, or illegal purposes. You are solely responsible for obtaining proper consent from your customers before sending them messages through our platform. IVision is not liable for messages sent by businesses using our platform without proper consent.</p>
          </div>

          <div style={section}>
            <h2 style={h2Style}>6. Acceptable Use</h2>
            <p style={pStyle}>You agree not to: use the Service for any unlawful purpose; transmit harmful, threatening, or harassing content; attempt to gain unauthorized access to other accounts or systems; interfere with or disrupt the Service; resell or redistribute the Service without authorization; or upload malicious code or content.</p>
          </div>

          <div style={section}>
            <h2 style={h2Style}>7. Data Ownership</h2>
            <p style={pStyle}>You retain ownership of all data you submit to the platform, including customer information, booking records, and business data. We do not claim ownership of your data. Upon account termination, you may request an export of your data within 30 days. After 30 days, we may delete your data in accordance with our data retention policies.</p>
          </div>

          <div style={section}>
            <h2 style={h2Style}>8. Service Availability</h2>
            <p style={pStyle}>We strive to maintain high availability of our Service but do not guarantee uninterrupted access. We may perform maintenance, updates, or experience downtime. We are not liable for any loss or damage resulting from Service unavailability.</p>
          </div>

          <div style={section}>
            <h2 style={h2Style}>9. Limitation of Liability</h2>
            <p style={pStyle}>To the maximum extent permitted by law, IVision Marketing LLC shall not be liable for any indirect, incidental, special, consequential, or punitive damages, including loss of profits, data, or business opportunities, arising from your use of the Service. Our total liability shall not exceed the amount you paid us in the 12 months preceding the claim.</p>
          </div>

          <div style={section}>
            <h2 style={h2Style}>10. Indemnification</h2>
            <p style={pStyle}>You agree to indemnify and hold harmless IVision Marketing LLC from any claims, damages, losses, or expenses arising from your use of the Service, your violation of these terms, or your violation of any rights of a third party.</p>
          </div>

          <div style={section}>
            <h2 style={h2Style}>11. Termination</h2>
            <p style={pStyle}>We may suspend or terminate your account at any time for violation of these terms. You may cancel your account at any time. Upon termination, your right to use the Service ceases immediately, though certain provisions of these terms will survive termination.</p>
          </div>

          <div style={section}>
            <h2 style={h2Style}>12. Governing Law</h2>
            <p style={pStyle}>These terms shall be governed by and construed in accordance with the laws of the State of Nevada, without regard to conflict of law principles. Any disputes arising under these terms shall be resolved in the courts located in Clark County, Nevada.</p>
          </div>

          <div style={section}>
            <h2 style={h2Style}>13. Changes to Terms</h2>
            <p style={pStyle}>We reserve the right to update these terms at any time. We will notify you of material changes by posting updated terms on this page. Continued use of the Service after changes constitutes acceptance of the new terms.</p>
          </div>

          <div style={section}>
            <h2 style={h2Style}>14. Contact Us</h2>
            <p style={pStyle}>If you have questions about these terms, contact us at:</p>
            <p style={pStyle}>IVision Marketing LLC<br />Las Vegas, Nevada<br />Email: support@ivisionmarketing.com<br />Website: ivisionmarketing.com</p>
          </div>
        </div>
      </div>
    </div>
  );
}
